import {DAILYLOG} from "../../../services";
import {FileController} from "../../Boilerplate/FileController";

const docKey = ['match', 'params', 'id'];
const subDocKey = ['match', 'params', 'dailyLogId'];
const indexType = 'dailylog';
const topLevelName = 'Daily Log';

export const DailyLogFiles = FileController(DAILYLOG, indexType, docKey, subDocKey, topLevelName);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogFiles.js